import React, { useEffect, useState } from "react";
import "react-toggle/style.css";
import Toggle from "react-toggle";
import styled from "styled-components";
import Tooltip from "./Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faC, faCheck } from "@fortawesome/free-solid-svg-icons";

/**
 * This component is instantiated when viewing the OptionsModal. There are several components
 * that might be rendered in the modal depending on the product being viewed; the logic for that
 * is in scripts/Components/Threekit/containers/ProductOptions.js. When this component is loaded,
 * logic has already been executed that finds the options that are supposed to be displayed, discards
 * any extraneous options, and passes whatever is left to this component. The option.value array always
 * has two items; index 0 is the option that incurs a fee, and index 1 is the option that does not.
 *
 * Typically we want to avoid hardcoding values like this, but because the sorting logic has already
 * happened by the time this component loads, we can rely on indexes 0 and 1 being present and having
 * the same structure.
 *
 * @param {Object} option - An option associated with the currently-selected product
 * @param {Object} optionsUtility - An instance of scripts/Components/Threekit/helpers.OptionsUtility.js
 * @returns
 */
export default function ToggleOption({ option, optionsUtility }) {
  const [checked, setChecked] = useState(option.values[0].selected);
  const handleChange = () => {
    setChecked(!checked);
  };

  useEffect(() => {
    if (checked) {
      optionsUtility.changeOptionToLabel(
        option.name,
        option.values[0].label,
        option.values[0].sku
      );
    } else {
      optionsUtility.changeOptionToLabel(
        option.name,
        option.values[1].label,
        option.values[1].sku
      );
    }
  }, [checked]);

  const price = option.values[0].price;

  return (
    <Container isOn={checked}>
      <ToggleContainer>
        <Toggle
          id={option.handle}
          defaultChecked={checked}
          onChange={handleChange}
          icons={{
            checked: <CheckIcon icon={faCheck} />,
            unchecked: <No>No</No>,
          }}
        />
        <Info>
          {option.name} + ${price}
        </Info>
        <Tooltip
          tooltipMessage={option.cod_tooltip_inner}
          tooltipHeadLine={option.title}
        />
      </ToggleContainer>
      {/* <Messsage>message</Messsage> */}
    </Container>
  );
}
const CheckIcon = styled(FontAwesomeIcon)`
  font-size: 14px;
  margin: 0;
  color: white;
  transform: translateY(-2px);
`;
const ToggleContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 16px;
`;
const Info = styled.p`
  margin: 0;
`;
const Messsage = styled.p`
  text-align: left;
  font-size: 15px;
  color: #707070;
  width: 100%;
  margin: 0;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  .react-toggle-thumb {
    display: block !important;
  }
  .react-toggle-track {
    backgrond-color: ${(props) => (props.isOn ? "#59c207" : "#707070")};
  }
  .react-toggle-track {
  }
  .react-toggle-thumb {
    scale: 0.8;
  }
`;

const No = styled.p`
  margin: 0;
  font-size: 14px;
  color: white;
  transform: translate(-4px, 5px);
`;
